import React from 'react';
import AboutInfo from '../../components/AboutPage/AboutInfo';
import FooterContact from '../../components/Footer/FooterContact';

export default function About() {
  return (
    <div>
      <AboutInfo />
      <FooterContact />
    </div>
  );
}
